<div>
  <p-toast [life]="3000" [sticky]="false"></p-toast>

  <!-- Card search -->
  <div *ngIf="resultDialog">
    <div class="cases-from">
      <div class="card">
        <form class="form-horizontal" (ngSubmit)="searchMemberSales($event)" #searchForm="ngForm">
          <div class="card-body after">
            <div class="d-flex flex-wrap align-items-end gap-3">
          
              <!-- Sistema -->
              <div class="form-group">
                <label>{{ "System" | translate }}</label>
                <select #search_company_id [focus]="selectFocused" name="company" class="form-control"
                        [(ngModel)]="company_id" required (ngModelChange)="onSelectCompany($event)">
                  <option value="apolo">APOLO</option>
                  <option value="mok">MOK</option>
                </select>
              </div>
          
              <!-- ======== APOLO ======== -->
              <ng-container *ngIf="company_id === 'apolo'">
          
                <!-- País -->
                <div class="form-group">
                  <label>{{ "Country" | translate }}</label>
                  <select #search_country_id [focus]="selectFocused" name="country" class="form-control"
                          [(ngModel)]="country_id" (ngModelChange)="onSelectCountry($event)" required>
                    <option *ngFor="let c of countries" [ngValue]="c.id">
                      <app-flags class="flag-position" [country]="c"></app-flags> {{ c.name }}
                    </option>
                  </select>
                </div>
          
                <!-- Tipo búsqueda -->
                <div class="form-group">
                  <label>{{ "Type Search" | translate }}</label>
                  <select #search_type name="typeSearch" class="form-control"
                          [(ngModel)]="typeSearch" (ngModelChange)="changeTypeSearch($event)" required>
                    <option [ngValue]="9">{{ "Search by name" | translate }}</option>
                    <option [ngValue]="11">{{ "Search by national ID" | translate }}</option>
                    <option [ngValue]="12">{{ "Search by phone" | translate }}</option>
                    <option [ngValue]="10">{{ "Assistance Code" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.BY_CONECTION">{{ "By Connection" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.MANUAL_CASE">{{ "Manual Case" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.CAR_PLATE">{{ "Search by car plate" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.CAR_ENGINE_NUMBER">{{ "Search by car engine number" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.CAR_SERIAL_NUMBER">{{ "Search by car serial number" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.EMAIL">{{ "Search by Email" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.TAX_NUMBER">{{ "Search by Tax Identification Number" | translate }}</option>
                  </select>
                </div>
          
                <!-- Estado -->
                <div class="form-group">
                  <label>{{ "Status" | translate }}</label>
                  <select #sale_status name="search_sale_status" class="form-control"
                          [(ngModel)]="search_sale_status">
                    <option [ngValue]="null">--- {{ 'All' | translate }} ---</option>
                    <option [ngValue]="1">{{ "Active" | translate }}</option>
                    <option [ngValue]="3">{{ "Canceled" | translate }}</option>
                  </select>
                </div>
          
                <!-- Entrada genérica -->
                <div class="form-group"
                     *ngIf="[9,10,11,12,99,50,55,TYPE_SEARCH.EMAIL,TYPE_SEARCH.TAX_NUMBER].includes(typeSearch)">
                  <label>{{ getSearchLabel(typeSearch) | translate }}</label>
                  <input class="form-control" type="text" name="membername" required
                         [disabled]="isMemberDisabled" [(ngModel)]="member_name"
                         placeholder="{{ 'Search...' | translate }}">
                </div>
          
                <!-- Clave–Póliza–Inciso -->
                <div class="d-flex flex-wrap gap-3" *ngIf="typeSearch == 3">
                  <div class="form-group">
                    <label>{{ "Key" | translate }}</label>
                    <input class="form-control" #search_key name="search_key" required
                           placeholder="{{ 'Key' | translate }}" [(ngModel)]="key">
                  </div>
                  <div class="form-group">
                    <label>{{ "Policy" | translate }}</label>
                    <input class="form-control" #search_policy name="search_policy" required
                           placeholder="{{ 'Policy' | translate }}" [(ngModel)]="policy">
                  </div>
                  <div class="form-group">
                    <label>{{ "Incised" | translate }}</label>
                    <input class="form-control" #search_inciso name="search_inciso" required
                           placeholder="{{ 'Incised' | translate }}" [(ngModel)]="inciso">
                  </div>
                </div>
          
                <!-- Búsqueda con componente -->
                <div class="flex-grow-1" *ngIf="typeSearch == 1">
                  <app-members-search (onSelect)="onSelectMember($event)" (onClear)="onClearSelectMember()"
                                      [placeholder]="'Search by name, phone, national ID'"
                                      [country_id]="country.id" [newMember]="member"
                                      [disabled]="isMemberDisabled" [member]="assistancecase.member"
                                      [clearMember]="clearMember" [isCase]="true">
                  </app-members-search>
                </div>
              </ng-container>
          
              <!-- ======== MOK ======== -->
              <ng-container *ngIf="company_id === 'mok'">
                <div class="form-group">
                  <label>{{ "Sponsor" | translate }}</label>
                  <select #search_sponsor_id name="sponsor" class="form-control"
                          [(ngModel)]="sponsor_id" (ngModelChange)="onSelectSponsor($event)" required>
                    <option *ngFor="let s of sponsors_mok" [ngValue]="s.id">{{ s.iso_code }} - {{ s.name }}</option>
                  </select>
                </div>
          
                <div class="form-group">
                  <label>{{ "Type Search" | translate }}</label>
                  <select #search_type name="typeSearch" class="form-control"
                          [(ngModel)]="typeSearch" (ngModelChange)="changeTypeSearch($event)" required>
                    <option [ngValue]="9">{{ "Search by Contract" | translate }}</option>
                    <option [ngValue]="11">{{ "Search by national ID" | translate }}</option>
                    <option [ngValue]="TYPE_SEARCH.EMAIL">{{ "Search by Email" | translate }}</option>
                  </select>
                </div>
          
                <div class="form-group" *ngIf="[9,11,TYPE_SEARCH.EMAIL].includes(typeSearch)">
                  <label>{{ typeSearch == 9 ? 'Contract' :
                           (typeSearch == 11 ? 'National ID' : 'Email') | translate }}</label>
                  <input class="form-control" type="text" name="membername" required
                         [(ngModel)]="member_name" placeholder="{{ 'Search...' | translate }}">
                </div>
              </ng-container>
          
              <!-- ======== BOTÓN ENVIAR ======== -->
              <div class="form-group ms-auto">
                <button type="submit" class="btn secundary-btn"
                        [disabled]="searchForm.form.invalid || searchForm.form.pending">
                  <ng-container *ngIf="typeSearch == TYPE_SEARCH.BY_CONECTION || typeSearch == TYPE_SEARCH.MANUAL_CASE;
                                       else lblSearch">
                    {{ "Continue" | translate }}
                  </ng-container>
                  <ng-template #lblSearch>{{ "Search" | translate }}</ng-template>
                </button>
              </div>
          
            </div>
          </div>
          
          
        </form>
      </div>
    </div>
  </div>

  <!-- Result after Search -->
  <div *ngIf="resultDialog">
    <div class="container-fluid">
      <div class="row mb-3 justify-content-center" *ngFor="let sale of sales; let i = index">
        <div class="card">
          <div class="card-header-search color">
            <div class="header-div-left">
              <ng-container *ngIf="sale?.PrimerNombre; else noClient1">
                <i class="far fa-user" aria-hidden="true"></i>
                {{ sale?.PrimerNombre | titlecase }}
                {{ sale?.ApellidoPaterno | titlecase }}
                {{ sale?.ApellidoMaterno | titlecase }}
              </ng-container>
              <ng-template #noClient1>
                <i class="far fa-user" aria-hidden="true"></i>
                {{ sale?.razonSocial | titlecase }}
              </ng-template>
            </div>
            <div class="header-div-center">
              {{ sponsor?.name }}
            </div>
            <div class="header-div-right">
              {{ sale?.Cobertura | titlecase }}
            </div>
          </div>
          <div class="card-body-search card-column-flex">
            <div class="card-center-flex up">
              <div class="width-md-row title-up">
                <p>
                  <img alt="" class="mrg-rg"
                    [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_vehiculo.svg' | company" />
                  <strong>{{ "Vehicle data" | translate }}</strong>
                </p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Brand" | translate }}:</strong>
                </p>
                <p>{{ sale?.Marca | titlecase }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Models2" | translate }}:</strong>
                </p>
                <p>{{ sale?.Tipo | titlecase }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Plate" | translate }}:</strong>
                </p>
                <p>{{ sale?.Placas }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Year" | translate }}:</strong>
                </p>
                <p>{{ sale?.Modelo }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Status" | translate }}:</strong>
                </p>
                <p [class.text-danger]="sale.Estatus != 'VIGENTE'" [class.text-success]="sale.Estatus == 'VIGENTE'">
                  <strong>
                    {{ sale?.Estatus | titlecase }}
                  </strong>
                </p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Serie" | translate }}:</strong>
                </p>
                <p>{{ sale?.NumeroSerie }}</p>
              </div>
            </div>
            <div class="card-center-flex color last">
              <div class="width-md-row title-up">
                <p>
                  <img alt="" class="mrg-rg"
                    [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_poliza.svg' | company" />
                  <strong>{{ "Policy data" | translate }}</strong>

                  <a class="member-info" style="color: black; text-decoration: none" (click)="onClickInfo(i)">
                    <i style="color: #0277BD;     margin-left: 5px;" class="fa fa-info-circle pointer"></i>
                  </a>
                </p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>#{{ "Policy" | translate }}:</strong>
                </p>
                <p>{{ sale?.Poliza }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Beginning of Validity" | translate }}:</strong>
                </p>
                <p>{{ sale?.InicioVigencia }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "End of Term" | translate }}:</strong>
                </p>
                <p>{{ sale?.FinVigencia }}</p>
              </div>
              <div class="width-md-row double-md">
              </div>
              <div class="width-md-row">
              </div>
            </div>
          </div>
          <div class="card-footer-search">
            <button *ngIf="sale.Estatus != 'VIGENTE'" type="button" class="btn secundary-btn me-3" (click)="
                selectChubbSale(sale);
                SALE_CANCELLED_THEN_BY_CONNECTION = true;
                displayButtonByConnection()
              ">
              {{ "Mark by Conection" | translate }}
            </button>
            <button [disabled]="sale.Estatus != 'VIGENTE'" type="button" class="btn btn-light btn primary-btn" (click)="
                selectChubbSale(sale); SALE_CANCELLED_THEN_BY_CONNECTION = false">
              {{ "Select" | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Result after Search Member -->
  <div *ngIf="resultDialog">
    <div class="container-fluid">
      <div class="row mb-3 justify-content-center" *ngFor="let sale of assistancesales; let i = index">
        <div class="card" *ngIf="!is_mok_search">
          <div class="card-header-search color">
            <div class="header-div-left">
              <ng-container>
                <i class="far fa-user" aria-hidden="true"></i>
                {{ sale.member.name | titlecase }}
              </ng-container>
            </div>
            <div class="header-div-center">
              {{ sale.plan.product.sponsor.name | titlecase }}
            </div>
            <div class="header-div-right">
              {{ sale.member.membercountry.name | titlecase }}
            </div>
          </div>
          <div class="card-body-search card-column-flex">
            <br>
            <table class="table table-striped table-condensed" aria-label="saletable">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ "Sale" | translate }}</th>
                  <th scope="col">{{ "Plan" | translate }}</th>
                  <th scope="col">{{ "Product" | translate }}</th>
                  <th scope="col">{{ 'Date Effective' | translate }}</th>
                  <th scope="col">{{ 'Cancellation Date' | translate }}</th>
                  <th scope="col">{{ 'Cancellation Reason' | translate }}</th>
                  <th scope="col">{{ 'Status' | translate }}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>{{ sale.code | titlecase }}
                    <span *ngIf="sale?.is_dependent">
                      - {{ "Dependent" | translate }}
                      <span *ngIf="sale?.dependent?.status == 0">
                        &#40;{{ "Inactive" | translate }}&#41;
                      </span>
                    </span>
                    <span *ngIf="!sale?.is_dependent">
                      - {{ "Holder" | translate }}
                    </span>
                  </td>
                  <td>{{ sale.plan.name | titlecase }}</td>
                  <td>{{ sale.plan.product.name | titlecase }}</td>
                  <td>{{ sale.date_effective | titlecase }}</td>
                  <td>{{ sale.date_canceled | titlecase }}</td>
                  <td>{{ sale.cancellation_reason | titlecase }}</td>
                  <td>{{ (getStatusText(sale.status) | titlecase) | translate }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table class="table table-striped table-condensed" aria-label="identitytable">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ "Identity" | translate }}</th>

                  <th scope="col">{{ "Name" | translate }}</th>

                  <th scope="col" *ngIf="sale?.car;">{{ "Car Plate" | translate }}</th>
                  <th scope="col" *ngIf="sale?.car;">{{ "Engine number" | translate }}</th>
                  <th scope="col" *ngIf="sale?.car;">{{ "Serial number" | translate }}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>{{ sale.member.national_id }}</td>

                  <td>{{ sale.member.name }}</td>

                  <td *ngIf="sale?.car;">{{ sale.car?.car_plate}}</td>
                  <td *ngIf="sale?.car;">{{ sale.car?.engine_number}}</td>
                  <td *ngIf="sale?.car;">{{ sale.car?.serial_number}}</td>
                  <ng-container *ngIf="sale.member_sale_classification == null; else notNullTemplate">
                    <td align="center" *ngIf="sale.member.member_classification" style="align-content: center;">
                      <img alt="" class="imagen"
                        [src]="getUrlImageMemberClassification(sale.member.member_classification)">
                    </td>
                    <td *ngIf="!sale.member.member_classification">
                    </td>
                  </ng-container>

                  <ng-template #notNullTemplate>
                    <td align="center" *ngIf="sale.member_sale_classification" style="align-content: center;">
                      <img alt="" class="imagen"
                        [src]="getUrlImageMemberClassification(sale.member_sale_classification)">
                    </td>
                    <td *ngIf="!sale.member_sale_classification">
                    </td>
                  </ng-template>

                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer-search">
            <button *ngIf="(sale.status != 1 && sale.status != 5) || sale?.dependent?.status == 0" type="button" class="btn secundary-btn me-3" (click)="
                onDropdownClick(sale);
                setCreateCaseByConnection();">
              {{ "Mark by Conection" | translate }}
            </button>
            <button [disabled]="(sale.status != 1 && sale.status != 5) || sale?.dependent?.status == 0" type="button" class="btn btn-light btn primary-btn"
              (click)="onDropdownClick(sale)">
              {{ "Select" | translate }}
            </button>
          </div>
        </div>
        <div class="card" *ngIf="is_mok_search">
          <div class="card-header-search color">
            <div class="header-div-left">
              <ng-container>
                <i class="far fa-user" aria-hidden="true"></i>
                {{ sale.first_name | titlecase }} 
                {{ sale.last_name | titlecase }}
              </ng-container>
            </div>
            <div class="header-div-center">
              {{ mok_sponsor_selected.name | titlecase }}
            </div>
            <div class="header-div-right">
              {{ country.name | titlecase }}
            </div>
          </div>
          <div class="card-body-search card-column-flex">
            <br>
            <table class="table table-striped table-condensed" aria-label="saletable">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ "Sale" | translate }}</th>
                  <th scope="col">{{ "Plan" | translate }}</th>
                  <th scope="col">{{ 'Product' | translate }}</th>
                  <th scope="col">{{ 'Date Effective' | translate }}</th>
                  <th scope="col">{{ 'Status' | translate }}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>{{ sale.unique_contract_id | titlecase }}</td>
                  <td>{{ sale.plan_name | titlecase }}</td>
                  <td>{{ sale.product_name | titlecase }}</td>
                  <td>{{ sale.start_date | titlecase }}</td>
                  <td>{{ (getStatusText(sale.active) | titlecase) | translate }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table class="table table-striped table-condensed" aria-label="identitytable">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ "Identity" | translate }}</th>

                  <th scope="col">{{ "Name" | translate }}</th>

                  <th scope="col" >{{ "Car Plate" | translate }}</th>
                  <th scope="col"></th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>{{ sale.national_id ? sale.national_id : sale.unique_contract_id }}</td>

                  <td>{{ sale.first_name }} {{ sale.last_name }}</td>

                  <td >{{ sale.vehicle_plate_number}}</td>
                  <td></td>
                  <td></td>

                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer-search">
            <button [disabled]="!sale.active || !sale.external_plan_id" type="button" class="btn btn-light btn primary-btn"
              (click)="onDropdownClick(sale)">
              {{ "Select" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="inline-paginator w-100 text-center mb-2">
        <p-paginator [rows]="conf.searchPage" [totalRecords]="totalCount" (onPageChange)="nextPage($event)">
        </p-paginator>
      </div>
    </div>
  </div>

  <!-- Result after Search Cover Letter-->
  <div *ngIf="resultDialog">
    <div class="cases-from">
      <div *ngIf="assistanceCoverLetters.length != 0" class="card">
        <div class="card-body-search card-column-flex">
          <div class="content-panel">
            <div class="table-responsive">
              <table class="table table-condensed table-striped" aria-label="companytable">
                <thead>
                  <tr>
                    <th scope="col">{{ 'ID' | translate }}</th>
                    <th scope="col">{{ "Company name" | translate }}</th>
                    <th scope="col">{{ "Product" | translate }}</th>
                    <th scope="col">{{ "Plan" | translate }}</th>
                    <th scope="col">{{ "Validity" | translate }}</th>
                    <th scope="col">{{ "Sponsor" | translate }}</th>
                    <th scope="col" class="text-center">{{ "Actions" | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let coverLetter of assistanceCoverLetters">
                    <td>
                      <span>{{ coverLetter.id || "N/A" }}</span>
                    </td>
                    <td>{{ coverLetter.name || "N/A" }}</td>
                    <td>{{ coverLetter.product?.name || "N/A" }}</td>
                    <td>{{ coverLetter.plan?.name || "N/A" }}</td>
                    <td>
                      {{
                      coverLetter.date_start
                      ? (coverLetter.date_start
                      | date: "dd/MM/yyyy":largeOffset)
                      : "N/A"
                      }}
                      -
                      {{
                      coverLetter.date_end
                      ? (coverLetter.date_end
                      | date: "dd/MM/yyyy":largeOffset)
                      : "N/A"
                      }}
                    </td>
                    <td>{{ coverLetter.sponsor?.name || "N/A" }}</td>
                    <td class="text-center">
                      <button type="button" class="btn primary-btn primary-btn-fw"
                        (click)="selectCoverLetter(coverLetter)">
                        {{ "Create" | translate }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Result after Select Customer Search -->
  <div [hidden]="!isChubbSaleSelected">
    <div class="cases-from mb-4">
      <div class="card">
        <form class="form-horizontal" #form="ngForm">
          <div class="card-header-search color">
            <div class="header-div-left">
              <ng-container *ngIf="assistancecase?.contact_name; else noClient">
                <i class="far fa-user" aria-hidden="true"></i>
                {{ assistancecase?.contact_name | titlecase }}
              </ng-container>
              <ng-template #noClient>
                <i class="far fa-user" aria-hidden="true"></i>
                {{ sale?.razonSocial | titlecase }}
              </ng-template>
            </div>
            <div class="header-div-center">
              {{ sponsor?.name }}
            </div>
            <div class="header-div-right">
              {{ sale?.Cobertura | titlecase }}
            </div>
          </div>
          <div class="card-body-search card-column-flex">
            <div class="card-center-flex color">
              <div class="width-md-row title-down">
                <p>
                  <img alt="" class="mrg-rg"
                    [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_poliza.svg' | company" />
                  <strong>{{ "Policy data" | translate }}</strong>

                  <a class="member-info" style="color: black; text-decoration: none" (click)="billInfo2.show($event)">
                    <i aria-hidden="true" style="color: #0277BD;     margin-left: 5px;"
                      class="fa fa-info-circle pointer"></i>
                  </a>
                </p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>#{{ "Policy" | translate }}:</strong>
                </p>
                <p>{{ sale?.code }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Beginning of Validity" | translate }}:</strong>
                </p>
                <p>{{ sale?.date_effective }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "End of Term" | translate }}:</strong>
                </p>
                <p>{{ sale?.expiration_date }}</p>
              </div>
              <div class="width-md-row double-md">
                <p>
                  <strong>{{ "Plan" | translate }}:</strong>
                </p>
                <p>
                  {{ sale ? sale?.plan?.name : planmanual}}
                </p>

              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Product" | translate }}:</strong>
                </p>
                <p>
                  {{ sale?.plan?.product?.name }}
                </p>
              </div>
            </div>
            <div class="card-center-flex color last" style="justify-content: space-around !important;">
              <div class="width-md-row">
                <p>
                  <strong>{{ "Available assists" | translate }}:</strong>
                </p>
                <p>{{ remaining_assistances || "0" }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Assists consumed" | translate }}:</strong>
                </p>
                <p>{{ used_services || "0" }}</p>
              </div>
              <div class="width-md-row">
                <button class="btn btn-light btn primary-btn" (click)="showAttachments()"><em
                    class="fa fa-folder-open"></em> Ver Condicionados </button>
              </div>
              <div class="width-md-row">
                <button class="btn btn-light btn primary-btn" (click)="showCaseHistory()"><em class="fa fa-list"></em>
                  Ver Historial </button>
              </div>
            </div>
            <div class="card-center-flex color last" style="justify-content: space-around !important;"
              *ngIf="buca_plan">
              <div class="width-md-row">
                <p>
                  <strong>{{ "Max Amount" | translate }}:</strong>
                </p>
                <p>{{ buca_max_amount || "0" }}</p>
              </div>
              <div class="width-md-row">
                <p>
                  <strong>{{ "Max Amount Available" | translate }}:</strong>
                </p>
                <p>{{ buca_amount_available || "0" }}</p>
              </div>
              <div class="width-md-row"></div>
              <div class="width-md-row"></div>
            </div>
          </div>
          <div class="flex-div-space">
            <div class="margin-div-form-md">
              <div class="card-body-search card-column-flex">
                <div class="div-flex">
                  <div class="div-flex column form-group">
                    <label class="control-label col-sm-12">{{ 'Contact Channel' | translate }}:</label>
                    <select name="state_origin_id" class="form-control" [(ngModel)]="assistancecase.contact_channel"
                      name="contact_channel" required>
                      <option [ngValue]="1">Llamada Telefonica</option>
                      <option [ngValue]="2">Whatsapp</option>

                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-div-space">
            <div class="margin-div-form-md">
              <div class="flex-div-space">
                <p>
                  <img alt="" class="mrg-rg"
                    [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/client_data.svg' | company" />
                  <strong>{{ "Client data" | translate }} </strong>
                </p>
              </div>
              <hr />
              <div>
                <div class="div-flex">
                  <div class="div-flex column form-group">
                    <label class="control-label col-sm-12">{{ 'Contact Name' | translate }}:</label>
                    <input type="text" class="form-control" pattern=".{1,150}" [(ngModel)]="assistancecase.contact_name"
                      name="contact_name" [disabled]="isFieldsMemberDataDisabled">
                  </div>
                </div>
                <div class="div-flex">
                  <div class="div-flex column form-group">
                    <label>{{ "Country code" | translate }}</label>
                    <select name="state_origin_id" class="form-control" [(ngModel)]="assistancecase.country_phone_code"
                      name="country_phone_code" required>
                      <option [ngValue]="502">+502 (Guatemala)</option>
                      <option [ngValue]="506">+506 (Costa Rica)</option>
                      <option [ngValue]="504">+504 (Honduras)</option>
                      <option [ngValue]="503">+503 (El Salvador)</option>
                      <option [ngValue]="505">+505 (Nicaragua)</option>
                      <option [ngValue]="507">+507 (Panama)</option>
                      <option [ngValue]="52">+52 (México)</option>
                      <option [ngValue]="1809">+1809 (República Dominicana)</option>
                      <option [ngValue]="1868">+1868 (Trinidad y Tobago)</option>
                      <option [ngValue]="1876">+1876 (Jamaica)</option>
                      <option [ngValue]="595">+595 (Paraguay)</option>
                    </select>
                  </div>

                  <div class="div-flex column form-group">
                    <label>{{ "Phone" | translate }} 1</label>
                    <input type="text" name="phone" class="form-control" required [(ngModel)]="assistancecase.phone"
                      #phone="ngModel" minlength="8" maxlength="9" autocomplete="off" />
                    <p *ngIf="phone.invalid && phone.touched" class="text-danger">Debe ingresar un número de 8-9 dígitos
                    </p>
                  </div>
                </div>
                <div class="div-flex">
                  <div class="div-flex column form-group">
                    <label>{{ "Phone" | translate }} 2 ({{
                      "optional" | translate
                      }})</label>
                    <input type="text" class="form-control" autocomplete="off" [(ngModel)]="assistancecase.phone2"
                      name="phone2"/>
                  </div>
                  <div class="div-flex column form-group">
                    <label>{{ "Email" | translate }}</label>
                    <!-- pattern="^[(a-z0-9\_\-\.)]+@[(a-z0-9\_\-\.)]+\.[(a-z)]{2,15}$" -->
                    <input type="email" pattern="^[(a-zA-Z0-9\_\-\.)]+@[(a-zA-Z0-9\_\-\.)]+\.[(a-zA-Z)]{2,15}$"
                      class="form-control" [(ngModel)]="assistancecase.email" name="email"/>
                  </div>
                  <div class="div-flex column"></div>
                </div>
                <div class="div-flex">
                  <div class="div-flex column form-group">
                    <label>{{ "Dependent not reported" | translate }}:</label>
                    <input type="text" class="form-control" pattern=".{1,150}"
                      (ngModelChange)="onChangeApplicantName($event)" [ngModel]="assistancecase.applicant_name"
                      name="applicant_name"/>
                  </div>
                </div>
                <div class="div-flex mb-3">
                  <div class="div-flex column w-100 form-group">
                    <label>{{ "Residence address" | translate }}</label>
                    <textarea type="text" class="form-control md" rows="3" cols="10" [(ngModel)]="complete_address2"
                      name="complete_address2" [disabled]="isFieldsMemberDataDisabled">
                              </textarea>
                  </div>
                </div>
                <div class="div-flex">
                  <button *ngIf="isFieldsMemberDataDisabled" type="button" class="btn secundary-btn rigth"
                    (click)="isFieldsMemberDataDisabled = !isFieldsMemberDataDisabled">
                    <i class="fas fa-sync-alt" aria-hidden="true"></i>
                    {{ "Update" | translate }}
                  </button>
                  <button *ngIf="!isFieldsMemberDataDisabled" type="button" class="btn secundary-btn rigth"
                    (click)="saveMemberData()">
                    <i class="fas fa-save" aria-hidden="true"></i>
                    {{ "Save" | translate }}
                  </button>
                  <button type="button" class="btn secundary-btn secundary-btn-fw" (click)="showHomeAddresHistory()">
                    {{ "Address History" | translate }}
                  </button>
                </div>
              </div>
            </div>
            <div class="margin-div-form-md" [hidden]="
                            this.assistancecategories.length == 0 ||
                            this.fastServices1.length == 0
                          ">
              <div class="flex-div-space">
                <p>
                  <strong> {{ "Select type of service" | translate }} </strong>
                </p>
              </div>
              <hr />
              <div class="flex-div-space-around">
                <button *ngFor="let service of fastServices1" class="btn-unselect" [ngClass]="{
                                selected:
                                  getSelectService() == service.equivalence_ ? true : false
                              }" (click)="
                                selectService(service.equivalence2_, service.equivalence_)
                              ">
                  <div class="div-btn-select-service" *ngIf="service.id != 0">
                    <span class="span-height">{{
                      service.value_ | translate
                      }}</span>
                  </div>
                  <div class="div-btn-select-service" *ngIf="service.id == 0">
                  </div>
                </button>
              </div>
              <div class="flex-div-space-around space" #divServices>
                <button *ngFor="let service of fastServices2" class="btn-unselect" [ngClass]="{
                                selected:
                                  getSelectService() == service.equivalence_ ? true : false
                              }" (click)="
                                selectService(service.equivalence2_, service.equivalence_)
                              ">
                  <div class="div-btn-select-service" *ngIf="service.id != 0">
                    <span class="span-height">{{
                      service.value_ | translate
                      }}</span>
                  </div>
                  <div class="div-btn-select-service" *ngIf="service.id == 0">
                  </div>
                </button>
                <button class="btn-unselect" [ngClass]="{
                                selected: getSelectService() == -1 ? true : false
                              }" (click)="selectService(-1, -1); showMoreServicesDialog = true">
                  <div class="div-btn-select-service">
                    <img alt="" class="icon-service"
                      [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/other_services.svg' | company" />
                    <span class="span-height">{{
                      "Other Service" | translate
                      }}</span>
                  </div>
                </button>
                <div (click)="getWithOfDivService()" class="card" [ngClass]="{
                                'card-service-info':
                                  getWithOfDivService() != 0 ? true : false,
                                color: getSelectService() != null ? true : false
                              }" #cardService>
                  <div class="card-body display">
                    <span class="span-height" style="margin-bottom: 8px">{{
                      editcategory?.name
                      }}</span>
                    <span class="span-height">{{
                      editservice?.name | titlecase
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="flex-div-space-around space">
                <div *ngIf="additionalplanservice && additionalplanservice.special_condition">
                  <div class="container mt-5 mb-5">
                    <div class="row">
                      <div class="col">
                        <div class="card" style="width:100%;">
                          <div class="card-container">
                            <div class="title-panel">
                              <h1 class="text-center">
                                Plan {{ 'Special condition/Observations' | translate }}:
                              </h1>
                            </div>
                            <div class="p-4">
                              <div class="container">
                                <div class="row mb-5">
                                  <div class="col">
                                    {{ additionalplanservice.special_condition }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="div-flex" *ngIf="hasSinisters && additionalplanservice?.sinister_apply != 1">
                <div class="div-flex column form-group">
                  <label>{{ "Associated sinister" | translate }}</label>
                  <select name="sinister_claim_id" class="form-control" [(ngModel)]="selectedSinister"
                    name="sinisted_id">
                    <option [ngValue]="null">---</option>
                    <option *ngFor="let claim of sinisterList" [ngValue]="claim.id">
                      <div>
                        <p><span class="bold-text">Claim number:</span> {{claim.claim_number}} <span class="bold-text">
                            | Fecha:</span> {{claim.claim_date | date:'d/M/y'}}</p>
                      </div>
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div class="card-center-flex up last"
            *ngIf="showcarflag && 
              (this.editticket.service_id == 13 || this.editticket.service_id == 173 || this.editticket.service_id == 16 || this.editticket.service_id == 17 || this.editticket.service_id == 18 || this.editticket.service_id == 14 || this.editticket.service_id == 150 || this.editticket.service_id == 616 || this.editticket.service_id == 895
                || this.editticket.service_id == 1208 || this.editticket.service_id == 1207 || this.editticket.service_id == 1206 || this.editticket.service_id == 1205 || this.editticket.service_id == 1000
              )">
            <div class="width-md-row title-up">
              <p>
                <img alt="" class="mrg-rg"
                  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_vehiculo.svg' | company" />
                <strong>{{ "Vehicle data" | translate }}</strong>
              </p>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Vehicles" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <select class="form-control" [(ngModel)]="selectedVehicleId" (ngModelChange)="onSelectVehicleId($event)"
                  name="vehicle">
                  <option [ngValue]="null">---</option>
                  <option *ngFor="let vehicle of vehicles" [ngValue]="vehicle?.id">
                    {{ vehicle?.car_plate }} - {{ vehicle?.car_brand }}
                  </option>
                </select>
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Brand" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off"
                  [(ngModel)]="editticket.brand_description" name="brand_description" required />
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Model" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off"
                  [(ngModel)]="editticket.model_description" name="model_description" required />
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Plate" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" pattern=".*\S+.*" autocomplete="off"
                  [(ngModel)]="editticket.car_plate" name="plate" required maxlength="20" />
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Year" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <select class="form-control" [(ngModel)]="selectYear" (ngModelChange)="onSelectYear($event)" name="year"
                  required>
                  <option [ngValue]="null">---</option>
                  <option *ngFor="let year of years" value={{year}}>
                    <span>{{year}}</span>
                  </option>
                </select>
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Color" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off"
                  [(ngModel)]="editticket.color_description" (ngModelChange)="onSelectColor($event)"
                  required name="color_description" />
              </div>
            </div>
          </div>
          <div class="card-center-flex up last"
            *ngIf="editcategory?.code_equivalence == 1100 && additionalplanservice.sinister_apply == 1 && planManualSelected?.sinister_plan == 1">
            <div class="width-md-row title-up">
              <p>
                <img alt="" class="mrg-rg"
                  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_vehiculo.svg' | company" />
                <strong>{{ "Vehicle data" | translate }}</strong>
              </p>
            </div>
           
                <div class="width-md-row">
                  <p>
                    <strong>{{ "Brand" | translate }}:</strong>
                  </p>
                  <div class="form-group pe-3 pb-3">
                    <input type="text" class="form-control" autocomplete="off"
                      [(ngModel)]="editticket.brand_description" name="brand_description" required />
                  </div>
                </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Model" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off"
                  [(ngModel)]="editticket.model_description" name="model_description" required />
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Plate" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" pattern=".*\S+.*" autocomplete="off"
                  [(ngModel)]="editticket.car_plate" name="plate" required />
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Year" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <select class="form-control" [(ngModel)]="selectYear" (ngModelChange)="onSelectYear($event)" name="year"
                  required>
                  <option [ngValue]="null">---</option>
                  <option *ngFor="let year of years" value={{year}}>
                    <span>{{year}}</span>
                  </option>
                </select>
              </div>
            </div>
            <div class="width-md-row">
              <p>
                <strong>{{ "Color" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off"
                  [(ngModel)]="editticket.color_description" (ngModelChange)="onSelectColor($event)"
                  required name="color_description" />
              </div>
            </div>
          </div>
          <div class="card-center-flex up last row"
            *ngIf="editcategory?.code_equivalence == 1100 && additionalplanservice.sinister_apply == 1">
            <div class="col-md-1"></div>
            <div class="col-md-2 title-up" style="align-items: center; display: flex;">
              <p>
                <img alt="" class="mrg-rg"
                  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_vehiculo.svg' | company" />
                <strong>{{ "Vehicle data" | translate }}</strong>
              </p>
            </div>
            <div class="col-md-2">
              <p>
                <strong>{{ "Plate" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off" [(ngModel)]="car_of_assistance.car_plate"
                  name="plate" required />
              </div>
            </div>
            <div class="col-md-2">
              <p>
                <strong>{{ "Year" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <select class="form-control" [(ngModel)]="car_of_assistance.car_year" name="year" required>
                  <option [ngValue]="null">---</option>
                  <option *ngFor="let year of years" [ngValue]="year">{{ year }}</option>
                </select>
              </div>
            </div>
            <div class="col-md-1"></div>
            <div class="col-md-1"></div>
            <div class="col-md-2">
              <p>
                <strong>{{ "Type" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off"
                  [(ngModel)]="car_of_assistance.type_description" name="type_description" required />
              </div>
            </div>
            <div class="col-md-2">
              <p>
                <strong>{{ "Color" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off"
                  [(ngModel)]="car_of_assistance.color_description" name="color_description" required />
              </div>
            </div>
            <div class="col-md-3">
              <p>
                <strong>{{ "Serial number" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off" [(ngModel)]="car_of_assistance.serial_number"
                  name="serial_number" />
              </div>
            </div>
            <div class="col-md-3">
              <p>
                <strong>{{ "Engine number" | translate }}:</strong>
              </p>
              <div class="form-group pe-3 pb-3">
                <input type="text" class="form-control" autocomplete="off" [(ngModel)]="car_of_assistance.engine_number"
                  name="engine_number" />
              </div>
            </div>
            <div class="col-md-1"></div>
          </div>

          <div>
            <div class="div-header-location">
              <p>
                <img alt="" class="mrg-rg"
                  [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_client.svg' | company" />
                <strong>{{ "Current location data" | translate }} </strong>
              </p>
              <hr class="hr-md" />
            </div>
            <div>
              <div class="flex-div-space-between">
                <div>
                  <div class="margin-div-form-md medio">
                    <p>{{ "Current location" | translate }}</p>
                    <div>
                      <div style="display: flex">
                        <button type="button" class="btn secundary-btn" (click)="viewCallDialog()">
                          {{ "Request Geolocation" | translate }}
                        </button>
                        <img alt="" class="mrg-lf" *ngIf="loaderLocation"
                          [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/loading_gif/loader.gif' | company"
                          style="height: 40px; width: auto" />
                      </div>
                    </div>
                  </div>

                  <!-- Current address -->
                  <div class="margin-div-form-md">
                    <div>
                      <p class="p-color">
                        <strong> {{ "Current address" | translate }} </strong>
                      </p>
                    </div>
                    <div>
                      <div>
                        <div class="div-flex">
                          <div class="div-flex column form-group">
                            <label>{{ "Country" | translate }}</label>
                            <select name="origin_country_id" class="form-control"
                              (ngModelChange)="onSelectCountryOrigin($event)"
                              [(ngModel)]="assistancecase.origin_country_id" required>
                              <option *ngFor="let country of countries" [ngValue]="country.id">
                                {{ country.name }}
                              </option>
                            </select>
                          </div>
                          <div class="div-flex column after form-group">
                            <label>{{ stateLabel }}</label>
                            <select name="state_origin_id" class="form-control" (ngModelChange)="onSelectState($event)"
                              [(ngModel)]="assistancecase.state_id"
                              [required]="editservice && editservice?.required_address == 1">
                              <option [ngValue]="null">---</option>
                              <option *ngFor="let state of states" [ngValue]="state.id">
                                {{ state.name }}
                              </option>
                            </select>
                          </div>
                          <div class="div-flex column after">
                            <label>{{ stateDistrictLabel }}</label>
                            <div class="form-group">
                              <select name="state_district_origin_id" class="form-control"
                                (ngModelChange)="onSelectStateDistrict($event)"
                                [(ngModel)]="assistancecase.state_district_id"
                                [required]="editservice && editservice?.required_address == 1">
                                <option [ngValue]="null">---</option>
                                <option *ngFor="let state of statesDistrict" [ngValue]="state.id">
                                  {{ state.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="div-flex">
                          <div class="div-flex column form-group">
                            <label>{{ "Postal code" | translate }}</label>
                            <input type="number" class="form-control" [(ngModel)]="assistancecase.postal_code"
                              name="postal_code" />
                          </div>
                          <div class="div-flex column form-group">
                            <label>{{ "Street" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="assistancecase.street" name="street">
                          </div>
                          <div class="div-flex column form-group">
                            <label>{{ "External number" | translate }}</label>
                            <input type="number" class="form-control" [(ngModel)]="assistancecase.zone" name="zone" />
                          </div>
                        </div>
                        <div class="div-flex">
                          <div class="div-flex column form-group">
                            <label>{{ "Suburb" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="assistancecase.suburb" name="suburb">
                          </div>
                          <div class="div-flex column form-group">
                            <label>{{ "Reference point" | translate }}</label>
                            <input type="text" class="form-control md" [(ngModel)]="assistancecase.reference"
                              name="reference" />
                          </div>
                        </div>
                        <div class="div-flex">
                          <div class="div-flex column w-100 form-group">
                            <label>{{ "Full Address" | translate }}</label>
                            <textarea type="text" class="form-control md" rows="3" cols="10"
                              [(ngModel)]="assistancecase.address" name="assistancecase_address"
                              [required]="editservice && editservice?.required_address == 1">
                            </textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="map-div-flex mb-3">
                  <app-select-location #selectLocationComp [location]="caseLocation" [memberLocation]="memberLocation"
                    [stateLocation]="stateLocation" [showMap]="showMap" [captureLocation]="true"
                    [member_id]="assistancecase.member_id" [email]="assistancecase.email" [phone]="assistancecase.phone" [otherPhone]="otherPhone"
                    [selectedPhone]="selectedPhone"
                    [requireDataLatLng]="true" [country_phone_code]="assistancecase.country_phone_code"
                    (selectLocation)="onSelectLocation($event)" [country_code]="country_id">
                  </app-select-location>
                  <label *ngIf="
                      (!this.editLocation.latitude ||
                        !this.editLocation.longitude)" class="text-danger fs-4">*{{ "Select an origin" | translate }}
                  </label>
                  <input type="hidden" class="form-control" [(ngModel)]="this.editLocation.latitude"
                    name="latitudeOrigin" />
                  <input type="hidden" class="form-control" [(ngModel)]="this.editLocation.longitude"
                    name="longitudeOrigin" />
                </div>
              </div>
            </div>

            <div class="flex-div-space-between" *ngIf="
                !this.editticket.service_id ||
                TYPE_SERVICES.TYPE_TRUCK == this.editticket.service_id || 
                TYPE_SERVICES.TYPE_TAXI == this.editticket.service_id || 
                TYPE_SERVICES.TYPE_TAXI_AIRPORT == this.editticket.service_id ||
                TYPE_SERVICES.TYPE_REPATRIATION == this.editticket.service_id ||
                TYPE_SERVICES.TYPE_TRUCK_MOTORCYCLE == this.editticket.service_id ||
                TYPE_SERVICES.TYPE_LOCKSMITH_VEHICLE_INSURED == this.editticket.service_id ||
                TYPE_SERVICES.TYPE_TIRE_CHANGE_VEHICLE_INSURED == this.editticket.service_id ||
                TYPE_SERVICES.TYPE_GASOLINE_VEHICLE_INSURED == this.editticket.service_id ||
                TYPE_SERVICES.TYPE_CURRENT_FLOW_VEHICLE_INSURED == this.editticket.service_id ||
                TYPE_SERVICES.TYPE_TRUCK_VEHICLE_INSURED == this.editticket.service_id ||
                ambulance_id.indexOf(this.editticket.service_id) >= 0
              ">
              <div>
                <!-- Direction of transfer -->
                <div class="margin-div-form-md">
                  <div>
                    <p>
                      <img alt="" class="mrg-rg"
                        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_client.svg' | company" />
                      <strong>{{ "Destination address" | translate }} </strong>
                    </p>
                    <hr class="hr-md" />
                  </div>
                  <div>
                    <div>
                      <div>
                        <div class="div-flex">
                          <div class="div-flex column form-group">
                            <label>{{ "Country" | translate }}</label>
                            <select name="destination_country_id" class="form-control"
                              (ngModelChange)="onSelectCountryDestination($event)"
                              [(ngModel)]="assistancecase.destination_country_id" required>
                              <option *ngFor="let country of countries" [ngValue]="country.id">
                                {{ country.name }}
                              </option>
                            </select>
                          </div>
                          <div class="div-flex column after">
                            <label>{{stateDestinationLabel}}</label>
                            <div class="form-group">
                              <select name="state_id" class="form-control" (ngModelChange)="onSelectStateTicket($event)"
                                [(ngModel)]="editticket.state_id" required>
                                <option [ngValue]="null">---</option>
                                <option *ngFor="let state of statesTicket" [ngValue]="state.id">
                                  {{ state.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="div-flex column after">
                            <label>{{ stateDistrictDestinationLabel }}</label>
                            <div class="form-group">
                              <select name="state_district_id" class="form-control"
                                [(ngModel)]="editticket.state_area_id" required>
                                <option [ngValue]="null">---</option>
                                <option *ngFor="let state of statesDistrictTicket" [ngValue]="state.id">
                                  {{ state.name }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="div-flex">
                          <div class="div-flex column">
                            <label>{{ "Postal code" | translate }}</label>
                            <input type="number" class="form-control" [(ngModel)]="editticket.postal_code_destination"
                              name="postal_code_destination" />
                          </div>
                          <div class="div-flex column">
                            <label>{{ "Street" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="editticket.street_destination"
                              name="street_destination" />
                          </div>
                          <div class="div-flex column">
                            <label>{{ "External number" | translate }}</label>
                            <input type="number" class="form-control" [(ngModel)]="editticket.zone_destination"
                              name="zone_destination" />
                          </div>
                        </div>
                        <div class="div-flex">
                          <div class="div-flex column s">
                            <label>{{ "Suburb" | translate }}</label>
                            <input type="text" class="form-control" [(ngModel)]="editticket.suburb_destination"
                              name="suburb_destination" />
                          </div>
                          <div class="div-flex column m">
                          </div>
                        </div>
                        <div class="div-flex">
                          <div class="div-flex column w-100 form-group">
                            <label>{{ "Full Address" | translate }}</label>
                            <textarea type="text" rows="3" cols="10" class="form-control md"
                              [(ngModel)]="editticket.address_destination" name="address_destination" required>
                            </textarea>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="map-div-flex">
                <app-select-location #selectLocationComp [location]="caseLocationDestination"
                  [memberLocation]="memberLocationDestination" [ticketstep]="true" [showMap]="showMap"
                  [requireDataLatLng]="true" [country_phone_code]="assistancecase.country_phone_code"
                  (selectLocation)="step1SetLocation($event)" [country_code]="country_id">
                </app-select-location>
                <label *ngIf="
                    (!this.editticket.latitude || !this.editticket.longitude)
                  " class="text-danger fs-4">*{{ "Select a destination" | translate }}</label>
                <input type="hidden" class="form-control" [(ngModel)]="this.editticket.latitude"
                  name="latitudeDestiny" />
                <input type="hidden" class="form-control" [(ngModel)]="this.editticket.longitude"
                  name="longitudeDestiny" />
              </div>
            </div>

            <!-- AMBULANCIAS -->
            <div class="container-morfeo mt-5 mb-5" *ngIf="ambulance_id.indexOf(this.editticket.service_id) >= 0">
              <div class="row">
                <div class="col-sm-12">
                  <div class="card">
                    <div class="card-container">
                      <div class="title-panel">
                        <h1 class="text-center">
                          <img
                            [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/currentflow.svg' | company"
                            alt="" class="me-3" />
                          {{
                          "To provide the service we need the following answers"
                          | translate
                          }}
                        </h1>
                      </div>


                      <div class="p-4">
                        <div class="container">
                          <div class="row mb-5">
                            <div class="form-group col-sm-6">
                              <label><strong>
                                  {{'Choose a color from the Triage'|translate}}
                                </strong></label>
                              <div>
                                <div class="col-sm-3" style="display: flex;
                              align-items: center;
                              justify-content: center;
                              width: 100%;">
                                  <button class="{{getclass1(1)}}" (click)="setRed()">Emergencia</button>
                                  <button class="{{getclass2(2)}}" (click)="setYellow()">Urgente</button>
                                  <button class="{{getclass3(3)}}" (click)="setGreen()">No Urgente</button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="container-morfeo mt-5 mb-5">
              <div class="row">
                <div class="col-sm-12">
                  <div class="card">
                    <div class="card-container">
                      <div class="title-panel">
                        <h1 class="text-center">
                          <img
                            [src]="(editservice.assistance_image_url || 'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/icon-survey.svg') | company"
                            alt="" class="me-3 icon-question" />
                          {{
                          "To provide the service we need the following answers"
                          | translate
                          }}
                        </h1>
                      </div>

                      <div class="p-4">
                        <div class="container">
                          <div class="row mb-5">
                            <div class="form-group col-sm-6" *ngFor="let question of questions">
                              <label><strong>{{question.order}}.
                                  {{question.question.question_text}}</strong></label>
                              <div *ngIf="question.question.type_ === QUESTION_TYPE.TYPE_TEXT.id">
                                <input type="text" class="form-control" [(ngModel)]="question.answer_text"
                                  name="question{{question.order}}" [required] = "!!question.is_required" />
                              </div>

                              <div *ngIf="question.question.type_ === QUESTION_TYPE.TYPE_RADIO.id">
                                <div class="form-check form-check-inline" *ngFor="let option of question.question.assistance_question_options">
                                  <input name="question{{question.order}}" class="form-check-input"
                                    type="radio" value="{{option.id}}" [required] = "!!question.is_required"
                                    [(ngModel)]="question.option_selected_id" />
                                  <label class="form-check-label">{{ option.option_value }}</label>
                                </div>
                              </div>
                              <div *ngIf="question.question.type_ === QUESTION_TYPE.TYPE_NUMBER.id">
                                <input name="question{{question.order}}" class="form-control" type="number"
                                  min="0" [required] = "!!question.is_required" [(ngModel)]="question.answer_text" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr class="hr-md" />
            <div
              *ngIf="showcarflag && (
                  this.editticket.service_id == 13 || this.editticket.service_id == 173 || this.editticket.service_id == 16 || this.editticket.service_id == 17 || this.editticket.service_id == 18 || this.editticket.service_id == 14 || this.editticket.service_id == 150 || this.editticket.service_id == 616 || this.editticket.service_id == 895
                  || this.editticket.service_id == 1208 || this.editticket.service_id == 1207 || this.editticket.service_id == 1206 || this.editticket.service_id == 1205 || this.editticket.service_id == 1000
                )">
              <div>
                <p class="p-color margin">
                  <strong>
                    {{ "Vehicle Reference (limit 200 characters)" | translate }}
                  </strong>
                </p>
              </div>
              <div class="comment-center">
                <textarea class="form-control txt-md" rows="3" cols="10" [(ngModel)]="editticket.vehicle_reference"
                  name="vehicle_reference" required>
                </textarea>
              </div>
            </div>

            <div *ngIf="TYPE_SERVICES.TYPE_TICKET_INFO.includes(this.editticket.service_id)">
              <div>
                <p class="p-color margin">
                  <strong>
                    {{ "Ticket information" | translate }}
                  </strong>
                </p>
              </div>
              <div class="comment-center">
                <textarea class="form-control txt-md" rows="3" cols="10" [(ngModel)]="assistancecase.case_ticket_info"
                  name="case_ticket_info" required>
                </textarea>
              </div>
            </div>
            <br>


            <br />
            <div>
              <p class="p-color margin">
                <strong> {{ "Comment" | translate }}: </strong>
              </p>
            </div>
            <div class="comment-center">
              <textarea class="txt-md form-control" rows="5" cols="10" [(ngModel)]="comment" name="comment" required>
              </textarea>
            </div>
          </div>
          <br />
          <div class="card-footer-create">
            <div class="secundarys-buttons">
              <button *ngIf="!flagProgramedService" type="button" class="btn secundary-btn rigth"
                (click)="displayViewProgramService()">
                {{ "Program Service" | translate }}
              </button>
              <button *ngIf="flagProgramedService" type="button" class="btn primary-btn-green rigth"
                (click)="showConfirmQuitProgram = true">
                <i class="fas fa-check" aria-hidden="true"></i>
                {{ "Scheduled service" | translate }}
              </button>
              <button *ngIf="!showConfirmByConection" type="button" class="btn secundary-btn"
                (click)="displayButtonByConnection()">
                {{ "Mark by Conection" | translate }}
              </button>
              <button *ngIf="showConfirmByConection" type="button" [disabled]="
                  typeSearch == TYPE_SEARCH.BY_CONECTION ||
                  SALE_CANCELLED_THEN_BY_CONNECTION
                " class="btn primary-btn-green" (click)="displayButtonByConnection()">
                <i class="fas fa-check" aria-hidden="true"></i>
                {{ "Dialed by connection" | translate }}
              </button>
              <button *ngIf="!showConfirmByRecordination" type="button" class="btn ms-3 secundary-btn"
                (click)="displayButtonByRecordination()">
                {{ "Recordination" | translate }}
              </button>
              <button *ngIf="showConfirmByRecordination" type="button" class="btn primary-btn-green"
                (click)="displayButtonByRecordination()">
                <i class="fas fa-check" aria-hidden="true"></i>
                {{ "Recordination" | translate }}
              </button>
            </div>
            <div class="primary-button">
              <button *ngIf="triageok_()" type="button" class="btn primary-btn" (click)="onSubmit()"
                [disabled]="form.form.invalid">
                {{ "Create Assistance Case" | translate }}
              </button>
              <button *ngIf="!triageok_()" type="button" class="btn primary-btn" (click)="onSubmit()" [disabled]="true">
                {{ "Create Assistance Case" | translate }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- Result after Select Cover Letter Search -->
  <div *ngIf="isCoverLetterSelected">
    <div class="cases-from">
      <div class="card">
        <div class="card-container">
          <div class="title-panel">
            <img alt="" class="go-to-back-title" (click)="backSearchCoverLetter()"
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company" />
            <h1 style="padding-left: 20px">
              {{ "Main Data" | translate }}
            </h1>
          </div>
          <div class="p-4">
            <form class="form-horizontal" #form="ngForm">
              <div class="mb-3 row">
                <div class="form-group text-start col-sm-12">
                  <label style="color: #01579B" class="control-label">
                    {{ "Client Data" | translate }}
                  </label>
                </div>
              </div>
              <div class="mb-3 row">
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "First Name" | translate }}:
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="sale.PrimerNombre" name="primerNombre"
                    pattern=".*\S+.*" required />
                </div>
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Middle Name" | translate }}:
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="sale.SegundoNombre" name="segundoNombre" />
                </div>
              </div>
              <div class="mb-3 row">
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Last Name" | translate }}:
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="sale.ApellidoPaterno" name="apellidoPaterno"
                    pattern=".*\S+.*" required />
                </div>
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Mother's last name" | translate }}:
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="sale.ApellidoMaterno" name="apellidoMaterno" />
                </div>
              </div>
              <div class="mb-3 row">
                <div class="form-group text-start col-sm-12">
                  <label style="color: #01579B" class="control-label">
                    {{ "Vehicle Data" | translate }}
                  </label>
                </div>
              </div>
              <div class="mb-3 row">
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Brand" | translate }}:
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="sale.Marca" name="marca" pattern=".*\S+.*"
                    required />
                </div>
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Year" | translate }}:
                  </label>
                  <input type="number" class="form-control" [(ngModel)]="sale.Modelo" name="modelo" pattern=".*\S+.*"
                    required />
                </div>
              </div>
              <div class="mb-3 row">
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Line" | translate }}:
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="sale.Tipo" name="tipo" pattern=".*\S+.*"
                    required />
                </div>
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Plate" | translate }}:
                  </label>
                  <input type="text" class="form-control" [(ngModel)]="sale.Placas" name="placas" pattern=".*\S+.*"
                    required />
                </div>
              </div>
              <div class="mb-5 row">
                <div class="form-group col-sm-6">
                  <label class="control-label">
                    {{ "Color" | translate }}:
                  </label>
                  <input class="form-control" [(ngModel)]="editticket.color_description"
                    (ngModelChange)="onSelectColor($event)" name="color_description" required />
                </div>
              </div>
              <div class="mb-3 row">
                <div class="col-md-12 text-end">
                  <button type="submit" class="btn primary-btn btn primary-btn-fw" (click)="selectChubbSale(sale)"
                    [disabled]="form.form.invalid || form.form.pending">
                    {{ "Continue" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Result after Select By conection  Search -->
  <div *ngIf="isConectionSelected">
    <div class="cases-from">
      <div class="card">
        <div class="card-container">
          <div class="title-panel">
            <img alt="" class="go-to-back-title" (click)="backGestionByConection()"
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company" />
            <h1 style="padding-left: 20px">
              {{ "Main Data" | translate }}
            </h1>
          </div>
          <div class="p-4">
            <form class="form-horizontal" #form="ngForm">
              <div class="mb-3 row">
                <div class="form-group text-start col-sm-12">
                  <label style="color: #01579B" class="control-label">
                    {{ "Client Data" | translate }}
                  </label>
                </div>
              </div>
              <div class="mb-3 row">
                <div class="form-group col-sm-6">
                  <label class="control-label">{{ 'Contact Name' | translate }}:</label>
                  <input type="text" class="form-control" pattern=".{1,150}" [(ngModel)]="assistancecase.contact_name"
                    name="contact_name">
                </div>
                <div class="form-group col-sm-6">
                  <label class="control-label">{{ 'National ID' | translate }}:</label>
                  <input type="text" class="form-control" [(ngModel)]="member_national_id" name="national_id">
                </div>
              </div>
              <div class="mb-3 row">
                <div class="col-md-12 text-end">
                  <button type="submit" class="btn primary-btn btn primary-btn-fw" (click)="onDropdownClick(sale)"
                    [disabled]="form.form.invalid || form.form.pending">
                    {{ "Continue" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Result after Select manual case  Search -->
  <div *ngIf="isManualSelected">
    <div class="cases-from">
      <div class="card">
        <div class="card-container">
          <div class="title-panel">
            <img alt="" class="go-to-back-title" (click)="backGestionByConection()"
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company" />
            <h1 style="padding-left: 20px">
              {{ "Main Data" | translate }}
            </h1>
          </div>
          <div class="p-4">
            <form class="form-horizontal" #form="ngForm">
              <div class="mb-3 row">
                <div class="form-group text-start col-sm-12">
                  <label style="color: #01579B" class="control-label">
                    {{ "Client Data" | translate }}
                  </label>
                </div>
              </div>
              <div class="mb-3 row">
                <div class="form-group col-sm-6">
                  <label class="control-label">{{ 'Contact Name' | translate }}:</label>
                  <input type="text" class="form-control" pattern=".{1,150}" [(ngModel)]="assistancecase.contact_name"
                    name="contact_name">
                </div>
                <div class="form-group col-sm-6">
                  <label class="control-label">{{ 'National ID' | translate }}:</label>
                  <input type="text" class="form-control" [(ngModel)]="member_national_id" name="national_id">
                </div>
              </div>


              <div class="mb-3 row">
                <div class="form-group col-sm-6">
                  <label class="control-label"> {{ 'Product' | translate }}:</label>
                  <select class="form-control" [ngModel]="productmanual" (ngModelChange)="onSelectProductManual($event)"
                    name="product" required>
                    <option [ngValue]="null">---</option>
                    <option *ngFor="let product of products" [ngValue]="product.id">
                      {{product.name}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-sm-6">
                  <label class="control-label">{{ 'Plan' | translate }}:</label>
                  <select class="form-control" [ngModel]="planmanual" (ngModelChange)="onSelectPlanManual($event)"
                    name="plan" required>
                    <option [ngValue]="null">---</option>
                    <option *ngFor="let plan of assistanceplans" [ngValue]="plan.id">
                      <span *ngIf="plan.base_price != null">
                        {{
                        plan.id + ' - ' +
                        plan.name + '(' + plan.currency.symbol
                        + plan.base_price + ')'
                        }}
                      </span>
                      <span *ngIf="plan.base_price == null">
                        {{ plan.name }}
                      </span>
                    </option>
                  </select>
                </div>
              </div>



              <div class="mb-3 row">
                <div class="col-md-12 text-end">
                  <button type="submit" class="btn primary-btn btn primary-btn-fw" (click)="onDropdownClick(sale)"
                    [disabled]="form.form.invalid || form.form.pending">
                    {{ "Continue" | translate }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>




<p-dialog [(visible)]="showUploadFileDialog" [responsive]="true" [class.ui-dialog-titlebar]="true" [modal]="true"
  [draggable]="false" [blockScroll]="true" [breakpoint]="500" [style]="{'width': '75vw' }">
  <ng-template pTemplate="header">
    
    {{ 'Attachment' | translate }}
  
  </ng-template>

  
  <div class="p-4">
    <div class="content-panel">
      <div class="table-responsive">
        <table class="table table-condensed table-striped" aria-label="filetypetable">
          <thead>
            <tr>
              <th scope="col">{{ 'ID' | translate }}</th>
              <th scope="col">{{ 'File Type' | translate }}</th>
              <th scope="col">{{ 'User' | translate }}</th>
              <th scope="col">{{ 'File' | translate }}</th>
              <th scope="col">{{ 'Date' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let caseAttachment of caseAttachments">
              <td>{{ caseAttachment.id }}</td>
              <td>{{ fileTypes[caseAttachment.attachment?.attachment_type] | translate }}</td>
              <td>{{ caseAttachment.attachment?.user?.username }}</td>
              <td>
                <a *ngIf="caseAttachment.attachment" class="link"
                  (click)="downloadAttachment(caseAttachment.attachment)" style="cursor: pointer">
                  {{ caseAttachment.attachment?.name }}
                </a>
                <span *ngIf="!caseAttachment.attachment">
                  {{ 'File not generated' | translate }}
                </span>
              </td>
              <td>
                {{
                caseAttachment.attachment?.created_time
                | currentDate: { offset: timezoneOffset }
                | date:'MMM'
                | translate
                }}
                {{
                caseAttachment.attachment?.created_time
                | currentDate: { offset: timezoneOffset }
                | date:'d' | translate
                }},
                {{
                caseAttachment.attachment?.created_time
                | currentDate: { offset: timezoneOffset }
                | date:'hh:mm a'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</p-dialog>

<p-dialog [(visible)]="showHistoryDialog" [responsive]="true" [class.ui-dialog-titlebar]="true" [modal]="true"
  [draggable]="false" [blockScroll]="true" [breakpoint]="500" [style]="{'width': '90vw' }">
  <ng-template pTemplate="header">
    
    {{ 'Historial de Casos' | translate }}
  
  </ng-template>

  
  <div class="p-4">
    <div class="content-panel">
      <app-assistance-cases-history *ngIf="sale" [setSale]="setSale"></app-assistance-cases-history>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="showPreviewDialog" [responsive]="true" [class.ui-dialog-titlebar]="true" [modal]="true"
  [draggable]="false" [blockScroll]="true" [breakpoint]="500" [style]="{'width': '75vw' }">
  <ng-template pTemplate="header">
    
    {{ 'Download Attachment' | translate }}
  
  </ng-template>

  

  <app-attachment-preview [setAttachment]="setAttachment" (cancelEvent)="closePreviewAttachment()"
    (download)="closePreviewAttachment()" #downloadForm>
  </app-attachment-preview>
</p-dialog>

<p-dialog [(visible)]="showCountryError" [modal]="true">
  <div class="comment-center">
    <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/query_error.svg' | company" />
    <br />
    <h2><strong>{{ 'Oops! It seems that you did not select country' | translate }}</strong></h2>
  </div>
</p-dialog>



<p-dialog [(visible)]="in_use_flag" [modal]="true" (onHide)="onHideActiveService()">
  <ng-template pTemplate="header">
    {{ 'Alert Same Services' | translate }}
  </ng-template>
  
  <div class="comment-center">

    <h2 style="color: red;"><strong>{{ 'No more than one active service allowed' | translate }}</strong></h2>
  </div>
</p-dialog>


<p-dialog [(visible)]="max_amount_flag" [modal]="true">
  <ng-template pTemplate="header">
    {{ 'Alert Max Amount' | translate }}
  </ng-template>
  
  <div class="comment-center">

    <h2 style="color: red;"><strong>{{ 'Alert! You are reaching your available limit' | translate }}</strong></h2>
  </div>
</p-dialog>

<p-dialog [(visible)]="max_amount_available_flag" [modal]="true">
  <ng-template pTemplate="header">
    {{ 'Alert Max Amount Reached' | translate }}
  </ng-template>
  
  <div class="comment-center">

    <h2 style="color: red;"><strong>{{ 'Alert! You no longer have the amount available, please provide the service via connection' | translate }}</strong></h2>
  </div>
</p-dialog>

<p-dialog [(visible)]="showPhonesNumberDialog" [modal]="true">
  <div>
    <h2>
      <strong>{{ "Confirm and select the phone number" | translate }}</strong>
    </h2>
    <hr />
    <div class="btns-popup-call">
      <div>
        <h2>{{ assistancecase.contact_name }}</h2>
      </div>
      <div class="form-check">
        <div>
          <input *ngIf="
              assistancecase.phone == null && assistancecase.phone2 == null
            " class="form-check-input" type="radio" name="flexRadioDefault" id="{{ assistancecase.phone }}"
            value="{{ assistancecase.phone }}" [checked]="checkedPhone"  (change)="onRadioPhoneChange(1)"/>
          <label *ngIf="
              assistancecase.phone == null && assistancecase.phone2 == null
            " class="form-check-label" for="{{ assistancecase.phone }}">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company" />
            +{{ assistancecase.country_phone_code }} ---
          </label>
        </div>
        <div>
          <input *ngIf="assistancecase.phone != null ? true : false" class="form-check-input" type="radio"
            name="flexRadioDefault" id="{{ assistancecase.phone }}" value="{{ assistancecase.phone }}"  [checked]="checkedPhone"  (change)="onRadioPhoneChange(1)"/>
          <label *ngIf="assistancecase.phone != null ? true : false" class="form-check-label"
            for="{{ assistancecase.phone }}">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company" />
            +{{ assistancecase.country_phone_code }} {{ assistancecase.phone }}
          </label>
        </div>

        <div>
          <input *ngIf="assistancecase.phone2 != null ? true : false" class="form-check-input" type="radio"
            name="flexRadioDefault" id="{{ assistancecase.phone2 }}" value="{{ assistancecase.phone2 }}" [checked]="checkedPhone"  (change)="onRadioPhoneChange(1)" />
          <label *ngIf="assistancecase.phone2 != null ? true : false" class="form-check-label"
            for="{{ assistancecase.phone2 }}">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company" />
            +{{ assistancecase.country_phone_code }}
            {{ assistancecase.phone2 ? assistancecase.phone2 : "---" }}
          </label>
        </div>
      </div>
    </div>
    <br />
    <div class="btns-popup-call">
      <div style="display: flex;">
        <h2 style="margin-right: 10px;">{{ "Other" | translate }}:</h2>
        <input class="form-check-input" type="radio"
         [checked]="checkedPhone2" (change)="onRadioPhoneChange(2)"/>
        <input type="text" name="otherPhone" class="form-control" required [(ngModel)]="otherPhone"
         minlength="8" maxlength="9" autocomplete="off"  />
       <!-- <p *ngIf="otherPhone.invalid && otherPhone.touched" class="text-danger">Debe ingresar un número de 8-9 dígitos</p> -->
   
      </div>
    </div>

    <div class="btns-popup-call">
      <div class="row">
        <div class="col">
          <button class="btn primary-btn buttonGreenWhite" (click)="
              requestLocation(selectLocationComponent.SHIPPING_METHOD.SMS);
              showPhonesNumberDialog = false
            ">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company" />
            {{ "Send link" | translate }}
          </button>
        </div>
      </div>
    </div>
    <!-- <hr />
    <div class="btns-popup-call">
      <div class="row">
        <div class="col" style="text-align: center">
          <h2>{{ "Send Link To Email" | translate }}:</h2>
          <button class="btn secundary-btn" [disabled]="!assistancecase.email" (click)="
              requestLocation(selectLocationComponent.SHIPPING_METHOD.EMAIL);
              showPhonesNumberDialog = false
            ">
            <i class="fa fa-envelope" aria-hidden="true"></i>
            {{ "Email" | translate }}
          </button>
        </div>
      </div>
    </div> -->
  </div>
</p-dialog>

<p-dialog [style]="{ width: '30vw' }" [(visible)]="showMoreServicesDialog" [modal]="true">
  <form (ngSubmit)="showMoreServicesDialog = false" #categoryServiceForm="ngForm">
    <div class="form-group">
      <label class="control-label col-sm-12">
        {{ "Category" | translate }}:
      </label>
      <div class="col-sm-12">
        <select class="form-control" [(ngModel)]="selectCategory_id" (ngModelChange)="onSelectCategory($event)"
          name="category" required>
          <option [ngValue]="null">---</option>
          <option *ngFor="let category of assistancecategories" value="{{ category.id }}">
            <span>{{ category.name }}</span>
          </option>
        </select>
      </div>
    </div>
    <div class="form-group">
      <label class="control-label col-sm-12">
        {{ "Service" | translate }}:
      </label>
      <div class="col-sm-12">
        <select class="form-control" [ngModel]="editticket.service_id" (ngModelChange)="onSelectService($event)"
          name="service" required>
          <option [ngValue]="null">---</option>
          <option *ngFor="let service of services" value="{{ service.id }}">
            <span>{{ service.name }}</span>
          </option>
        </select>
      </div>
    </div>
    <br />
    <div class="cases-from">
      <button class="btn secundary-btn" (click)="showMoreServicesDialog = false">
        {{ "Cancel" | translate }}
      </button>
      <button [disabled]="
          categoryServiceForm.form.invalid || categoryServiceForm.form.pending
        " type="submit" class="btn primary-btn btn-margin">
        {{ "Accept" | translate }}
      </button>
    </div>
  </form>
</p-dialog>

<!-- VISTA DE ASISTENCIA PROGRAMADA -->
<div class="cases-from" *ngIf="showProgramedService">
  <img alt="" class="go-to-back" (click)="onCloseServiceProgramed()"
    [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back.svg' | company" />
  <form class="card" #form="ngForm">
    <div class="card-header-search color">
      {{ "Schedule Assistance" | translate }}
    </div>
    <div class="card-header-search padding">
      <div>
        <h2 class="h2-center">
          <strong>{{ "Select the scheduling reason" | translate }}</strong>
        </h2>
        <div class="cases-from">
          <div class="card" style="width: 100%">
            <div class="form-check">
              <table class="table-exceptions" aria-label="itemtable">
                <th scope="col"></th>
                <tr *ngFor="let item of assistance_programming_types">
                  <td>
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="{{ item.id }}"
                      value="{{ item.id }}" (change)="onChangeItemSelected(item)" ngModel required />
                    <label class="form-check-label" for="{{ item.id }}">
                      {{ item.name }}
                    </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div>
        <h2 class="h2-center">
          <strong>{{ "Select the scheduling sub reason" | translate }}</strong>
        </h2>
        <div class="cases-from">
          <div class="card" style="width: 100%">
            <div class="form-check">
              <table class="table-exceptions" *ngIf="!assistance_programming_subtypes.length"
                aria-label="noaplicatable">
                <th scope="col"></th>
                <tr>
                  <td>
                    <input class="form-check-input" type="radio" name="program_subtype" value="{{ null }}"
                      (change)="onSelectProgramSubType_($event, null)" ngModel />
                    <label class="form-check-label">
                      {{ "No Aplica" }}
                    </label>
                  </td>
                </tr>
              </table>
              <table class="table-exceptions" *ngIf="assistance_programming_subtypes.length"
                aria-label="assistancetable">
                <th scope="col"></th>
                <tr *ngFor="let item of assistance_programming_subtypes">
                  <td>
                    <input class="form-check-input" type="radio" name="program_subtype" id="{{ item.code}}"
                      value="{{ item.code }}" (change)="onSelectProgramSubType_($event, item.code)" ngModel required />
                    <label class="form-check-label" for="{{ item.id }}">
                      {{ item.description_es }}
                    </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>


      <div class="div-vl"></div>

      <div>
        <h2 class="h2-center">
          <strong>{{ "Select date and time for attendance" | translate }}</strong>
        </h2>
        <p-datepicker [inline]="true" [required]="true" name="dateControl" [showTime]="true" hourFormat="24"
          [(ngModel)]="programTimeService"></p-datepicker>
      </div>
    </div>
    <br />
    <!-- footer -->
    <div class="card-header-search brd">
      <div class="card-buttons-footer">
        <div class="card-left-footer"></div>
        <div class="card-right-footer">
          <button class="btn secundary-btn" (click)="onCloseServiceProgramed()">
            {{ "Cancel" | translate }}
          </button>
          <button class="btn primary-btn btn-margin" [disabled]="form.form.invalid" (click)="onSetServiceProgramed()">
            {{ "Program" | translate }}
          </button>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- CONFIRMACION DE SERVICIO POR CONEXION -->
<p-dialog [(visible)]="showConfirmQuitProgram" [modal]="true">
  <div class="tr-header-center">
    <h2 class="h2-margin-btm">
      {{ "Confirmation" | translate }}
    </h2>
    <h3 class="h3-margin-btm">
      {{ "Are you sure you want to remove the scheduled service?" | translate }}
    </h3>
    <div>
      <button class="btn secundary-btn btn-margin" (click)="showConfirmQuitProgram = false">
        {{ "No" | translate }}
      </button>
      <button class="btn primary-btn" (click)="displayViewProgramService()">
        {{ "Yes" | translate }}
      </button>
    </div>
  </div>
</p-dialog>



<!-- Price info -->
<p-popover #billInfo [dismissable]="true">
  <div class="price-info-panel">
    <div *ngIf="sales.length>0" class="price-attributes-panel">
      <p>
        <strong>{{ "Grouping id" | translate }}:</strong>
        {{ sales[indexselectsale].AgrupacionId ? sales[indexselectsale].AgrupacionId : "N/A" }}
      </p>

      <p>
        <strong>{{ "Grouping" | translate }}:</strong>
        {{ sales[indexselectsale].Agrupacion? sales[indexselectsale].Agrupacion : "N/A" }}
      </p>
    </div>

    <div *ngIf="sales.length>0 && sales[indexselectsale].CondicionesEspeciales.length > 0"
      class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
      style="border-bottom: 1px solid #e7e7e7; margin-bottom: 11px;">
      <h3 style="font-style: normal; font-weight: 700; font-size: 1rem; line-height: 21px; margin-top: 21px;">
        {{"Special conditions" | translate}} </h3>



    </div>

    <div *ngIf="sales.length>0 && sales[indexselectsale].CondicionesEspeciales.length > 0">

      <p>
        <strong>{{ "Id assistance" | translate }}:</strong>
        {{ sales[indexselectsale].CondicionesEspeciales[0].IdentificadorDeAsistencia?
        sales[indexselectsale].CondicionesEspeciales[0].IdentificadorDeAsistencia : "N/A" }}
      </p>

      <p>
        <strong>{{"Text assistance" | translate }}:</strong>
        {{ sales[indexselectsale].CondicionesEspeciales[0].TextoLibreAsistencia?
        sales[indexselectsale].CondicionesEspeciales[0].TextoLibreAsistencia : "N/A" }}
      </p>

      <p>
        <strong>{{ "Apply survey"| translate }}:</strong>
        {{ sales[indexselectsale].CondicionesEspeciales[0].AplicaEncuesta?
        "Si" : "No" }}
      </p>

      <p>
        <strong>{{ "Apply alerts"| translate }}:</strong>
        {{ sales[indexselectsale].CondicionesEspeciales[0].AplicaAlertas?
        "Si" : "No" }}
      </p>

      <p>
        <strong>{{ "Mail alerts"| translate }}:</strong>
        {{ sales[indexselectsale].CondicionesEspeciales[0].CorreoDeAlertas?
        sales[indexselectsale].CondicionesEspeciales[0].CorreoDeAlertas : "N/A" }}
      </p>
    </div>
  </div>
</p-popover>





<!-- POLICY 2 info -->
<p-popover #billInfo2 [dismissable]="true">
  <div class="price-info-panel">
    <div *ngIf="assistancecase.grouping_id" class="price-attributes-panel">
      <p>
        <strong>{{ "Grouping id" | translate }}:</strong>
        {{ assistancecase.grouping_id ? assistancecase.grouping_id : "N/A" }}
      </p>

      <p>
        <strong>{{ "Grouping" | translate }}:</strong>
        {{ assistancecase.grouping_chubb? assistancecase.grouping_chubb : "N/A" }}
      </p>
    </div>

    <div *ngIf="assistancecase.attendance_identifier" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
      style="border-bottom: 1px solid #e7e7e7; margin-bottom: 11px;">
      <h3 style="font-style: normal; font-weight: 700; font-size: 1rem; line-height: 21px; margin-top: 21px;">
        {{"Special conditions" | translate}} </h3>



    </div>

    <div *ngIf="assistancecase.attendance_identifier">

      <p>
        <strong>{{ "Id assistance" | translate }}:</strong>
        {{ assistancecase.attendance_identifier?
        assistancecase.attendance_identifier : "N/A" }}
      </p>

      <p>
        <strong>{{"Text assistance" | translate }}:</strong>
        {{ assistancecase.free_text_attendance?
        assistancecase.free_text_attendance : "N/A" }}
      </p>

      <p>
        <strong>{{ "Apply survey"| translate }}:</strong>
        {{ assistancecase.apply_survey?
        "Si" : "No" }}
      </p>

      <p>
        <strong>{{ "Apply alerts"| translate }}:</strong>
        {{ assistancecase.apply_alerts?
        "Si" : "No" }}
      </p>

      <p>
        <strong>{{ "Mail alerts"| translate }}:</strong>
        {{ assistancecase.alert_mail?
        assistancecase.alert_mail : "N/A" }}
      </p>
    </div>
  </div>
</p-popover>